// Support-csapatok feature — query-kulcs gyár + a lista-szűrő típusa. A tényleges hívásokat a route a tipizált
// ts-rest kliensen (`api.supportTeams.*`) intézi; a kulcsok itt élnek (cache-invalidálás egységesen).
// A `@atlas/contracts` a szerződés forrás-igazsága — itt csak kulcs/segéd-logika van.

/** A lista-lekérdezés szűrői (a query-kulcs része — szűrő-váltás új cache-bejegyzést nyit).
 *  A rendezés-KULCS fixen a név (locale-collation, szerver-oldal) — csak az irány (`order`) váltható. */
export interface SupportTeamListFilters {
  q: string;
  order: 'asc' | 'desc';
}

/** Query-kulcs gyár — a lista-cache egységes címzése. */
export const supportTeamKeys = {
  all: ['support-teams'] as const,
  lists: () => ['support-teams', 'list'] as const,
  list: (filters: SupportTeamListFilters & { lang: 'hu' | 'en' }) =>
    ['support-teams', 'list', filters] as const,
};
